var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{staticClass:"notFound",attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"text-center"},[_c('h1',[_vm._v("Page Not Found")]),_c('p',[_vm._v(" 잘못된 접근입니다. 주소를 확인해주세요. ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }